export default function XML_Elements() {
  return (
    <div>
      <h1>XML_Elements</h1>
      <p>This is the XML_Elements component.</p>
    </div>
  );
}